/**
 * Klantenlijst links (ontwerp 31): één veld "Zoek op alles" (250 ms
 * wachten na de laatste toets) en per klant naam, moment, plaats, aantal
 * bestellingen en dieren. De gekozen klant is gemarkeerd.
 */
import { useEffect, useState } from "react";

import { Icoon } from "../Icoon";
import { useKlantenLijst } from "./lijstQuery";
import { aantalWoord, momentKort } from "./opmaak";

const ZOEK_WACHT_MS = 250;

export function KlantenLijst({
  gekozen,
  onKies,
  zoek,
  onZoek,
}: {
  gekozen: string | null;
  onKies: (klantId: string) => void;
  zoek: string;
  onZoek: (zoek: string) => void;
}) {
  const [invoer, setInvoer] = useState(zoek);
  useEffect(() => {
    if (invoer.trim() === zoek) return;
    const t = window.setTimeout(() => onZoek(invoer.trim()), ZOEK_WACHT_MS);
    return () => window.clearTimeout(t);
  }, [invoer, zoek, onZoek]);

  const lijst = useKlantenLijst(zoek);
  const klanten = lijst.data?.klanten ?? [];

  return (
    <>
      <div className="kl-lijst-bovenin">
        <label className="kl-zoek">
          <Icoon naam="zoek" klein />
          <input
            type="search"
            placeholder="Zoeken"
            aria-label="Zoek op alles"
            value={invoer}
            onChange={(e) => setInvoer(e.target.value)}
          />
        </label>
      </div>
      <div className="kl-lijst-scrol">
        {lijst.isLoading ? (
          <p className="v6-leeg">Laden</p>
        ) : lijst.isError ? (
          <p className="v6-fout kl-marge" role="alert">
            Laden mislukt
          </p>
        ) : klanten.length === 0 ? (
          <p className="v6-leeg">Geen klant gevonden</p>
        ) : (
          <ul aria-label="Klanten">
            {klanten.map((k) => {
              const onder = [
                k.woonplaats,
                k.aantal_orders > 0
                  ? aantalWoord(k.aantal_orders, "bestelling", "bestellingen")
                  : "nog geen bestelling",
                k.dieren.length > 0 ? k.dieren.join(", ") : null,
              ].filter(Boolean);
              return (
                <li key={k.id} className={`kl-regel${k.id === gekozen ? " on" : ""}`}>
                  <button
                    type="button"
                    aria-current={k.id === gekozen ? "true" : undefined}
                    onClick={() => onKies(k.id)}
                  >
                    <span className="naam">{k.naam}</span>
                    <span className="tijd num">{momentKort(k.laatste_contact_op)}</span>
                    <span className="onder">{onder.join(" · ")}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
}
